import { Box } from "theme-ui";
import { Accordion } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  Box,
  Accordion,
  React
};